import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

/*
  自定义 dom  v-track 指令, 用于统计用户响应, v-track指令名称默认增加了 click_ 标识点击触发
  使用：<div v-track="{ name: 'vip', params: { a: 1 } }"></div>
*/
Vue.directive('track', {
  bind: function (el, binding, vnode) {
    if (binding.value) {
      $(el).on('click', (e) => {
        store.dispatch('track/septTrack', {
          name: 'click_' + binding.value.name,
          params: binding.value.params
        })
      })
    }
  }
})

/*
  全局 $track 方法，用于记录特殊的用户响应，name需要手动添加 click_ or start_ 标识触发方式
  使用：this.$track('start_vip', { a: 1 })
*/
Vue.prototype.$track = (name, params) => {
  store.dispatch('track/septTrack', {
    name: name,
    ...params
  })
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

const DEBUG = false

if (DEBUG) {
  $('#app').append('<div class="clear-user">清除登录信息啦</div>')
  $('.clear-user').on('click', function() {
    window.localStorage.clear()
    window.location.reload(true)
  })
}
